import React, { useEffect, useState, useMemo } from "react"
import API from "../../Common/API"
import InlineTextField from "../../Components/InLineTextField";
import DatatableLoader from "../../Components/Loaders/DataTableLoader"
import { datatableTheme } from "../../Common/dataTableTheme"
import DataTable, { createTheme } from "react-data-table-component"
import { motion } from 'framer-motion'
import { useHistory } from "react-router-dom";
import { FaEye, FaPlus } from "react-icons/fa6";
import { FaCheckCircle, FaImage, FaImages, FaPen, FaTrash } from "react-icons/fa";
import Dialog from '../../Components/Dialog'
import Button from "../../Components/Button";
import { useDispatch } from "react-redux";
import { setAlert } from "../../Store/Theme/actions";
import dummy from '../../Assets/Images/dummyProfile.jpeg'

createTheme('defaultLight', datatableTheme.default)
createTheme('defaultDark', datatableTheme.dark)
const status = [{ id: 0, value: 'Pending' }, { id: 1, value: 'Approved' }, { id: 2, value: 'Declined' }, { id: 3, value: 'In-active' }, { id: 4, value: 'Happy customer' }, { id: 5, value: 'Blocked' },{id:6,value:'Under Review'}]
const PendingUsers = ({ match }) => {

    const [loading, setLoading] = useState(true)
    const [filter, setFilter] = useState('')
    const [userList, setUserList] = useState([])
    const history = useHistory()
    const [userId, setUserId] = useState()
    const [openEditModal, setOpenEditModal] = useState(false)
    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [openActiveModal, setOpenActiveModal] = useState(false)
    const dispatch = useDispatch()
    const [count, setCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1); // Assuming page index starts at 1
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalUsers,setTotalUsers] = useState()

    useEffect(() => {
        setLoading(true)
        API.get(`/user/getUserListByStatus/${match.params.status}`).then((userRes) => {
            if (userRes.status === 200) {
                setUserList(userRes.data.data.users)
                setTotalUsers(userRes.data.data.totalUsers)
                setLoading(false)
            }
        })
    }, [count,currentPage,rowsPerPage])

    const columns = useMemo(() => [
        { name: 'S.No', selector: (row, i) => (currentPage - 1) * rowsPerPage + i + 1, sortable: true, width: '100px' },
        {
            name : <FaImage/>, selector:(row,i)=> <motion.div className="w-full h-full px-2 py-1 flex flex-row text-center justify-center items-center"><img src={row?.images.length > 0 ? row?.images[0]?.imageUrl : dummy} alt="user" className="w-50 h-32 object-contain" /></motion.div>,
            initialActive: true, sortable: true,
        },
        { name: 'Ref Id', selector: (row, i) => row.refId, initialActive: true, sortable: true, width: '100px' },
        { name: 'First Name', selector: row => row.firstName, sortable: true },
        { name: 'Surname', selector: row => row.surname, sortable: true },
        // { name: 'Native', selector: row => row.familyInformation.fatherNative, sortable: true },
        { name: 'Mobile', selector: row => row?.contactInformation?.mobileNumber, sortable: true },
        { name: "Verification", selector: row => status.filter((x) => x.id === row.status)[0].value, sortable: true },
        { name: "Status", selector: row => row.activeStat === 'A' ? "Active" : "Deactived", sortable: true },
        {
            name: "Action", selector: row => <motion.div className="flex flex-row w-full gap-3 justify-between">
                <FaEye title="View" className="cursor-pointer text-green-900 " onClick={() => viewUser(row)} />
                <FaPen title="Edit" className="cursor-pointer text-indigo-900 " onClick={() => editUser(row)} />
                <FaImages title="Manage Images" className="cursor-pointer text-indigo-900 " onClick={() => history.push(`/manageImages/${row._id}`)} />
                {/* <MdPublishedWithChanges title="Change Status" className="cursor-pointer text-indigo-900 " onClick={() => history.push(`/manageImages/${row._id}`)} /> */}
                {row.activeStat === 'A' ? <FaTrash title="Delete" className="cursor-pointer text-[red] " onClick={() => deactivateUser(row)} /> :
                    <FaCheckCircle title="Delete" className="cursor-pointer text-[green] " onClick={() => activateUser(row)} />}
            </motion.div>, sortable: true
        },
    ], [currentPage, rowsPerPage])// eslint-disable-line

    const filteredcasedetails = useMemo(() => {
        const filterSplit = filter.toLowerCase().split(' ').filter(Boolean);
    
        const flattenObjectToString = (obj) => {
            let result = '';
            const stack = [obj];
    
            while (stack.length) {
                const current = stack.pop();
                for (const key in current) {
                    const value = current[key];
                    if (value && typeof value === 'object') {
                        stack.push(value);
                    } else if (value != null) {
                        result += ' ' + value.toString().toLowerCase();
                    }
                }
            }
    
            return result;
        };
    
        const highPriority = [];
        const others = [];
    
        userList.forEach((user) => {
            const firstName = user?.firstName?.toLowerCase() || '';
            const searchString = flattenObjectToString(user);
    
            const matchesAll = filterSplit.every((kw) => searchString.includes(kw));
            const firstNameMatchesAll = filterSplit.every((kw) => firstName.includes(kw));
    
            if (matchesAll) {
                if (firstNameMatchesAll) {
                    highPriority.push(user); // strong match on firstName
                } else {
                    others.push(user); // fallback match
                }
            }
        });
    
        return [...highPriority, ...others];
    }, [userList, filter]);

    const SubHeader = useMemo(() => (
        <div className="flex flex-row items-center">
            <motion.div className="bg-primeColor rounded-full px-2 py-1 mx-2 flex flex-row items-center text-white cursor-pointer" onClick={()=>downloadAsExcel(match.params.status)}>Export As Excel</motion.div>
            <InlineTextField label={"Search"} value={filter} setValue={setFilter} />
            <motion.div className="h-9 mx-2 w-9 rounded-full bg-white flex flex-col items-center cursor-pointer justify-center" onClick={() => history.push(`/createUser`)}><FaPlus /></motion.div>
        </div>
    ), [filter])// eslint-disable-line

    const editUser = (values) => {
        // setUserId(values)
        // setOpenEditModal(true)
        history.push(`/edit/${values._id}`)
    }

    const viewUser = (values) => {
        // setUserId(values)
        // setOpenEditModal(true)
        history.push(`/view/${values._id}`)
    }
    const deactivateUser = (values) => {
        setUserId(values._id)
        setOpenDeleteModal(true)
    }

    const activateUser = (values) => {
        setUserId(values._id)
        setOpenActiveModal(true)
    }

    const deleteUser = () => {
        try {
            API.post(`/user/deactivateUser/${userId}`).then((deRes) => {
                if (deRes.status === 200) {
                    dispatch(setAlert({ title: 'Error', subtitle: 'User Deactivated Successfully', active: true, type: 'error' }))
                    setOpenDeleteModal(false)
                    setCount(count + 1)
                }
            })
        } catch (err) {
            dispatch(setAlert({ title: 'Error', subtitle: 'Something went wrong', active: true, type: 'error' }))
        }
    }

    const reactiveUser = () => {
        try {
            API.post(`/user/activateUser/${userId}`).then((deRes) => {
                if (deRes.status === 200) {
                    dispatch(setAlert({ title: 'Error', subtitle: 'User activated Successfully', active: true, type: 'error' }))
                    setOpenActiveModal(false)
                    setCount(count + 1)
                }
            })
        } catch (err) {
            dispatch(setAlert({ title: 'Error', subtitle: 'Something went wrong', active: true, type: 'error' }))
        }
    }

     const downloadAsExcel = async (status)=>{
        try{
            const response = await API.get(`/user/xlsxUsersDownload/${status}`, {
                responseType: 'blob', // Ensure response is treated as a Blob
            })
            const fileName = status === '0' ? 'Pending_User_List' : status == '1' ? 'Approved_User_List' : status === '4' ? "Happy_Customer_List" : status === '2' ? 'Deactivated_User_List' : status === '7' && 'Paid_Members_List'
            if (response.status === 200) {
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${fileName}.xlsx`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }
        }catch(err){    
            console.log(err)
            dispatch(setAlert({title:'Error',subtitle:'Something went wrong while downloading',active:true,type:'error'}))
        }
    }

    return (
        <motion.div>
            {loading ? (
                <DatatableLoader />
            ) : (
                <motion.div className="h-full w-full bg-opacity-10 drop-shadow-lg">
                     {/* <DataTable
  title="User List"
  theme="defaultLight"
  columns={columns}
  data={filteredcasedetails}
  pagination
  paginationServer
  paginationTotalRows={totalUsers}
  paginationPerPage={rowsPerPage}
  paginationDefaultPage={currentPage} // <<— control page number
  onChangePage={val => setCurrentPage(val)}
  highlightOnHover
  selectableRowsHighlight
  persistTableHead
  subHeader
  subHeaderComponent={SubHeader}
  noDataComponent="There are no records to display"
/> */}
<DataTable
                        title="User List"
                        theme="defaultLight"
                        columns={columns}
                        data={filteredcasedetails}
                        pagination
                        highlightOnHover
                        selectableRowsHighlight
                        persistTableHead
                        subHeader
                        subHeaderComponent={SubHeader}
                        noDataComponent={'There are no records to display'}
                    />
                </motion.div>
            )}
            <Dialog injectClass="w-350px" showDialog={openDeleteModal} title={'Deactivate User'} onClose={() => setOpenDeleteModal(false)}>
                <motion.div className="w-full flex flex-col">
                    Are you sure you want to deactivate this user.
                    <motion.div className="w-full flex flex-row justify-between">
                        <Button injectClass={'bg-[red]/90 text-white rounded-full cursor-pointer'} onClick={() => setOpenDeleteModal(false)}>No</Button>
                        <Button injectClass={'bg-[green] text-white rounded-full cursor-pointer'} onClick={() => deleteUser()}>Yes</Button>
                    </motion.div>
                </motion.div>
            </Dialog>
            <Dialog injectClass="w-350px" showDialog={openActiveModal} title={'Activate User'} onClose={() => setOpenActiveModal(false)}>
                <motion.div className="w-full flex flex-col">
                    Are you sure you want to activate this user.
                    <motion.div className="w-full flex flex-row justify-between">
                        <Button injectClass={'bg-[red]/90 text-white rounded-full cursor-pointer'} onClick={() => setOpenActiveModal(false)}>No</Button>
                        <Button injectClass={'bg-[green] text-white rounded-full cursor-pointer'} onClick={() => reactiveUser()}>Yes</Button>
                    </motion.div>
                </motion.div>
            </Dialog>
        </motion.div>
    )
}

export default PendingUsers